module.exports = __webpack_public_path__ + "img/head_portrait.80365061.png";